import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
  currentPage: 0,
  hasMore: true,
  totalHits: 0,
  searchQuery: "",
  isSearching: false,
  creatorFilter: null, // { uid: string, displayName: string }
  isFilteringByCreator: false,
};

export const communitySlice = createSlice({
  name: "communitySlice",
  initialState,
  reducers: {
    setCommunityFiles: (state, action) => {
      state.files = action.payload;
    },
    appendCommunityFiles: (state, action) => {
      state.files = [...state.files, ...action.payload];
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    setTotalHits: (state, action) => {
      state.totalHits = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setIsSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = "";
      state.isSearching = false;
    },
    setCreatorFilter: (state, action) => {
      state.creatorFilter = action.payload; // { uid, displayName }
      state.isFilteringByCreator = true;
    },
    setIsFilteringByCreator: (state, action) => {
      state.isFilteringByCreator = action.payload;
    },
    clearCreatorFilter: (state) => {
      state.creatorFilter = null;
      state.isFilteringByCreator = false;
    },
  },
});

export const { 
  setCommunityFiles, 
  appendCommunityFiles, 
  setCurrentPage, 
  setHasMore, 
  setTotalHits,
  setSearchQuery,
  setIsSearching,
  clearSearch,
  setCreatorFilter,
  setIsFilteringByCreator,
  clearCreatorFilter
} = communitySlice.actions;
export default communitySlice.reducer;
